import * as Stimulus from "@hotwired/stimulus"

export class ImageSelectorController extends Stimulus.Controller {
    static get targets() {
        return ['preview'];
    }

    setPreviewImg(e) {
        if (e.target.tagName == 'IMG' && this.hasPreviewTarget) {
            let newPreview = e.target.cloneNode();
            newPreview.classList.add("w-full", "aspect-video", "object-cover");
            this.previewTarget.replaceChildren(newPreview);
        }
    }
}
